<template>
  <div class="ui-raiting">
    <div class="raiting">
      <div
          @click="edit(mark)"
          :class="[{ active: value - 1 >= index }]"
          class="star"
          v-for="(mark, index) in 5"
          :key="index"
      >
        <icon-star></icon-star>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default() {
        return 0
      }
    },
    allowEdit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    iconStar: () => import('@/components/icon/icon-star')
  },
  methods: {
    edit(mark) {
      if (this.allowEdit) {
        this.$emit('input', mark)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-raiting {
  display: inline-flex;
  align-items: center;
}
.star {
  display: inline-block;
  margin-right: 5px;
  position: relative;
  top: 0.2em;
  opacity: 0.4;
  cursor: pointer;
  &.active {
    opacity: 1;
  }
}
.raiting {
  display: flex;
  align-items: center;
}
.amount {
  margin-left: 0.5em;
}
.code {
  margin-left: auto;
}
</style>
